export const ERRORS: any = {
  10401: 'promo_code',
  10403: 'apply_promo_code_after_login',
};
